import { render } from "./WalletManagement.vue?vue&type=template&id=36965dd8&scoped=true"
import script from "./WalletManagement.vue?vue&type=script&lang=js"
export * from "./WalletManagement.vue?vue&type=script&lang=js"

import "./WalletManagement.vue?vue&type=style&index=0&id=36965dd8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36965dd8"]])

export default __exports__